"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ast_1 = require("../../util/ast");
exports.arrayElement = ({ ast, execObject }) => {
    const variableName = ast.children.arrayElement[0].children.IdentifierSuffix[0].image.slice(0, -1);
    const index = ast_1.getIndex({
        ast: ast.children.arrayElement[0].children.rules[0],
        execObject,
    });
    return execObject.manager.variable.reference(variableName, index);
};
